<template>
  <!-- <div>手机端网站开发中</div> -->
  <div
    style="
      padding: 100% 0;
      background: #5fbfe5;
      display: flex;
      flex-direction: column;
      align-items: center;
    "
  >
    <img src="@/assets/image/kfz.jpeg" style="width: 100%" />
    <span style="font-size: 16px">移动端开发中</span>
    <span style="font-size: 16px">请登录电脑端访问</span>
  </div>
</template>

<script>
export default {
  components: {},
  data() {
    return {};
  },
  created() {},
  mounted() {},
  watch: {},
  methods: {},
};
</script>

<style>
/* .detail p{
  line-height: 1.75em !important;

} */
</style>



// WEBPACK FOOTER //
// src/view/phone/phone.vue